export const MDT_SESSION_ACTIVE_KEY = 'c2_mdt_session_active';
export const MDT_RESOURCE_KEY = 'c2_mdt_resource';
export const MDT_EVENT_KEY = 'c2_mdt_event';

export function isSessionActive(): boolean {
  return localStorage.getItem(MDT_SESSION_ACTIVE_KEY) === '1';
}

export function markSessionActive(): void {
  localStorage.setItem(MDT_SESSION_ACTIVE_KEY, '1');
}

export function clearSessionActive(): void {
  localStorage.removeItem(MDT_SESSION_ACTIVE_KEY);
}

export function clearMdtStorage(): void {
  localStorage.removeItem(MDT_RESOURCE_KEY);
  localStorage.removeItem(MDT_EVENT_KEY);
  clearSessionActive();
}

export function getStoredMdtEvent(): { id: string; name?: string; status?: string } | null {
  try {
    const stored = localStorage.getItem(MDT_EVENT_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return parsed?.id ? parsed : null;
  } catch {
    return null;
  }
}

/** MDT may only operate on live events — not closed. */
export function isMdtSelectableEvent(event: { status?: string } | null | undefined): boolean {
  const status = event?.status;
  return status === 'open' || status === 'supervision';
}

/** MDT session event — user selection wins over resource.eventId (callsigns repeat across events). */
export function getMdtEventId(mdtResource?: { eventId?: string } | null): string | null {
  const selected = getStoredMdtEvent();
  if (selected?.id) return selected.id;
  if (mdtResource?.eventId) return mdtResource.eventId;
  return null;
}

/** Clear claimed unit if it belongs to a different event than the one selected on sign-in. */
export function reconcileMdtResourceWithEvent(
  mdtEvent: { id: string } | null,
  mdtResource: { id?: string; eventId?: string } | null
): boolean {
  if (!mdtEvent?.id || !mdtResource?.id) return false;
  if (!mdtResource.eventId || mdtResource.eventId === mdtEvent.id) return false;
  localStorage.removeItem(MDT_RESOURCE_KEY);
  return true;
}
